<template>
    <div id="select-year-filed" class="aisea-text-16-400-black">
      <!-- <v-select
        name="target_year_month"
        placeholder="年月を選択"
        :value="selectedYearMonth"
        :clearable="false"
        :options="yearMonthList"
        label="label"
        :disabled="yearMonthList.length === 0"
        @input="handleChange"
        style="min-width: 133px"
      >
        <template v-slot:no-options>-</template>
      </v-select> -->
      <!-- <treeselect
          placeholder="年のプルダウン"
          class="aaaaa"
        ></treeselect> -->
      <treeselect
        v-model="selectedYear"
        :options="yearOptions"
        :multiple="false"
        :clearable="false"
        placeholder="年"
        noOptionsText="なし"
        class="mr-4 my-1"
        @input="onFilterChanged"
        noResultsText="見つかりませんでした"
      ></treeselect>
    </div>
  </template>
  
  
  <script>
//   import vSelect from "vue-select";

import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

const YEARS = ["2023", "2024", "2025"];
  
  export default {
    name: "SelectYearField",
    mixins: [],
    components: {
    //   vSelect,
      Treeselect,
    },
    props: {
      selectedYear: { Type: Object, default: () => null },
      yearList: { Type: Array, default: [] },
      changeSelectedYearMonth: { Type: Function, default: () => {} },
    //   selectedYearMonth: { Type: Object, default: () => null },
    //   yearMonthList: { Type: Array, default: [] },
    //   changeSelectedYearMonth: { Type: Function, default: () => {} },
    },
    data() {
      return {
        selectedYear: 2023,
        // yearOptions: [
        //   {
        //   id: 2022,
        //   label: 2022,
        //   },
        // ],
      // yearOptions: YEARS.map((year, index) => {
      //   return {
      //     id: index + 1,
      //     label: year,
      //   };
      // }),
        yearOptions: this.generateYearOptions(2023),
      };
    },
    watch: {},
    computed: {},
    methods: {
      handleChange(nextYearMonth) {
        this.changeSelectedYearMonth(nextYearMonth);
      },
      onFilterChanged() {
        console.log("onFilterChanged()");
      },
      generateYearOptions(startYear) {
        const currentYear = moment().year();
        const yearArray = [];

        for (let year = startYear; year >= currentYear; year--) {
          yearArray.push({
            id: year,
            label: `${year}年`,
          });
        }

        return yearArray;
    },
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {},
    beforeUpdate() {},
    updated() {},
    beforeDestroy() {},
    destroyed() {},
  };
  </script>
  
  <style lang="scss">
  @import "@/assets/scss/aisea/_variables.scss";
  #select-year-filed {
    display: flex;
    --vs-dropdown-min-width: 133px;
    .vs__dropdown-menu {
      max-height: 200px;
    }
  }
  </style>
  